import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL } from 'services/api/apiConfig'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

export const postManageDataBlendMarketData = async ({ body }) => {
  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/manage-data/blend-market-data/${selectedApplication}`, 'POST', body)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting blend market data')
        reject(error)
      })
  })
}

export const postManageDataBlendMarketDataHeader = async ({ body }) => {
  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/manage-data/blend-market-data/${selectedApplication}/header`, 'POST', body)
      .then(data => {
        // @ts-ignore
        resolve(data)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting blend market data')
        reject(error)
      })
  })
}

/**
 * Delete the blend.
 * @param {number} marketDataHeaderKey - The ID of the blend.
 * @returns {Promise<string>} - A promise that resolves to a confirmation message.
 */
export const deleteBlend = async marketDataHeaderKey => {
  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/surveys/blend/${marketDataHeaderKey}`, 'DELETE')
      .then(data => {
        // @ts-ignore
        resolve(data)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error deleting survey ')
        reject(error)
      })
  })
}

export const postManageDataBlendMarketDataExport = async ({ body }) => {
  try {
    return await callApi(`${baseURL}/manage-data/blend-market-data/${selectedApplication}/export`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting blend market data')
    throw error
  }
}
